var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useMemo, useRef } from "react";
import Input from "../../atoms/input/input";
import JSQuestionnaireFooter from "../../molecules/jsQuestionnaireFooter/jsQuestionnaireFooter";
import "./jsQuestionnaire.css";
import MatrixRadioSelect from "../../molecules/matrixRadioSelect/matrixRadioSelect";
import { validateFormData, generateRandomFormData, } from "../../pages/questionnaire/questionnaires/validationUtils";
import ErrorMessage from "../../atoms/errorMessage/errorMessage";
import JSQuestionnaireHeader from "../../molecules/jsQuestionnaireHeader/jsquestionnaireHeader";
import DevModeButton from "../../atoms/devModeButton/devModeButton";
import IsMobile from "../../../hooks/isMobile";
import QuestionnaireSlider from "../../atoms/questionnaireSlider/questionnaireSlider";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { QuestionnaireDraftAction } from "../../../redux/actions/job_seeker_questionnaire";
import { Status } from "../../../redux/constants/status";
import { getResumableDomain, toDraftAnswers, } from "../../../utils/questionnaireProgress";
/**
 * The Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * This Page fetches the list of questions for each Questionnaire type.
 * The Questions in the questionnaire could be of 5 types:
 * => RadioSelect, CheckboxSelectMultiple, MatrixRadioSelect, TextInput, and Select.
 * The conditions, classes and response handling have been added for each type and their final reponses will be returned.
 * @param props
 * @returns
 */
function QuestionnaireOrg(props) {
    var _a;
    var data = props.data;
    var handleSubmit = props.handleSubmit, handleBackBtn = props.handleBackBtn;
    var responseData = props.responses;
    var isLoading = (_a = props.loading) !== null && _a !== void 0 ? _a : false;
    var isMobile = IsMobile();
    var responsesKey = JSON.stringify(responseData !== null && responseData !== void 0 ? responseData : {});
    var emptyformData = useMemo(function () {
        var result = {};
        data.forEach(function (obj) {
            if (!obj)
                return;
            var keys = Object.keys(obj);
            if (keys.length === 0)
                return;
            var key = keys[0];
            var field = obj[key];
            if (!field)
                return;
            if (key === "matrix_Radio_Select_Array" && field.data) {
                field.data.forEach(function (el) {
                    if (!el)
                        return;
                    if (Array.isArray(el)) {
                        result[el[0]] = responseData[el[0]] || "";
                    }
                    else {
                        var key1 = Object.keys(el)[0];
                        if (key1)
                            result[key1] = responseData[key1] || "";
                    }
                });
            }
            else {
                if (field.field_type === "CheckboxSelectMultiple") {
                    var value = responseData[key];
                    result[key] = typeof value === "string" ? value.split(",") : [];
                }
                else {
                    result[key] = responseData[key] || "";
                }
            }
        });
        return result;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, responsesKey]);
    var _b = useState(emptyformData), formData = _b[0], setFormData = _b[1];
    var _c = useState(emptyformData), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = useState(""), submitError = _d[0], setSubmitError = _d[1];
    var previousEmptyFormData = useRef(emptyformData);
    useEffect(function () {
        var previous = previousEmptyFormData.current;
        previousEmptyFormData.current = emptyformData;
        setFormData(function (prev) { return (__assign(__assign({}, emptyformData), Object.fromEntries(Object.entries(prev).filter(function (_a) {
            var k = _a[0], v = _a[1];
            return k in emptyformData && v !== previous[k];
        })))); });
    }, [emptyformData]);
    var handleChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value, type = _a.type;
        setFormData(function (prevFormData) {
            var _a, _b, _c;
            var _d;
            var newFormData = __assign({}, prevFormData);
            switch (type) {
                case "radio":
                    newFormData = __assign(__assign({}, prevFormData), (_a = {}, _a[name] = value, _a));
                    break;
                case "checkbox": {
                    var currVal = prevFormData[name];
                    var isValuePresent = currVal.includes(value);
                    var updatedVal = isValuePresent
                        ? currVal.filter(function (entity) { return entity !== value; })
                        : __spreadArray(__spreadArray([], currVal, true), [value], false);
                    newFormData = __assign(__assign({}, prevFormData), (_b = {}, _b[name] = updatedVal, _b));
                    break;
                }
                case "text":
                    newFormData = __assign(__assign({}, prevFormData), (_c = {}, _c[name] = value, _c));
                    break;
            }
            var updatedByParent = (_d = props.onChange) === null || _d === void 0 ? void 0 : _d.call(props, newFormData);
            return updatedByParent !== null && updatedByParent !== void 0 ? updatedByParent : newFormData;
        });
    };
    var handleSelect = function (e) {
        var _a;
        var _b;
        var _c = e.target, name = _c.name, value = _c.value;
        var newFormData = __assign(__assign({}, formData), (_a = {}, _a[name] = value === "Select One" ? "" : value, _a));
        var updatedByParent = (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, newFormData);
        setFormData(updatedByParent !== null && updatedByParent !== void 0 ? updatedByParent : newFormData);
    };
    var handleInputType = function (type) {
        if (type === "RadioSelect" || type === "MatrixRadioSelect") {
            return "radio";
        }
        else if (type === "CheckboxSelectMultiple") {
            return "checkbox";
        }
        return undefined;
    };
    var handleResponse = function (name, value, type) {
        if (type === "RadioSelect" || type === "MatrixRadioSelect") {
            return formData[name] === value;
        }
        else if (type === "CheckboxSelectMultiple") {
            var values = formData[name];
            return (values === null || values === void 0 ? void 0 : values.includes(value)) || false;
        }
        return false;
    };
    // Check if on wellbeing or progression page
    var SLIDER_PAGES = ["Personal Wellbeing", "Adviser Progression", "Your Path to Employment"];
    var isSlider = SLIDER_PAGES.includes(props.title);
    // A slider that was never moved still shows 0, so it is answered as 0
    var answersWithSliderDefaults = function () {
        if (!isSlider || isMobile)
            return formData;
        var answers = __assign({}, formData);
        var defaultToZero = function (key) {
            if (!answers[key])
                answers[key] = "0";
        };
        data.forEach(function (obj) {
            var key = obj && Object.keys(obj)[0];
            var field = key ? obj[key] : undefined;
            if (!key || !field)
                return;
            if (key === "matrix_Radio_Select_Array" && field.data) {
                field.data.forEach(function (el) {
                    if (el && !Array.isArray(el) && Object.keys(el)[0])
                        defaultToZero(Object.keys(el)[0]);
                });
            }
            else if (field.field_type === "RadioSelect" && field.choices) {
                defaultToZero(key);
            }
        });
        return answers;
    };
    var handleFormSubmit = function () {
        var answers = answersWithSliderDefaults();
        var validation = validateFormData(answers, data);
        var mergedErrors = {};
        // Run custom validation if provided
        if (props.customValidation) {
            mergedErrors = props.customValidation(answers);
        }
        if (!(validation === null || validation === void 0 ? void 0 : validation.isValid) && (validation === null || validation === void 0 ? void 0 : validation.errorField)) {
            var errorId_1 = validation.errorField;
            setErrorMessage(function (prev) {
                var _a;
                return (__assign(__assign(__assign({}, prev), (_a = {}, _a[errorId_1] = validation.errorMessage || "", _a)), mergedErrors));
            });
            if (validation.errorMessage) {
                setSubmitError("Please answer all questions to proceed*");
            }
        }
        else if (Object.keys(mergedErrors).length > 0) {
            // If only custom validation errors exist
            setErrorMessage(function (prev) { return (__assign(__assign({}, prev), mergedErrors)); });
            setSubmitError("Please answer all questions to proceed*");
        }
        else {
            handleSubmit === null || handleSubmit === void 0 ? void 0 : handleSubmit(answers);
        }
    };
    var handleFormBackBtn = function () {
        handleBackBtn === null || handleBackBtn === void 0 ? void 0 : handleBackBtn();
    };
    // "Save and Continue Later" is offered on the jobseeker questionnaire pages
    // that can be resumed; the answers given so far on this page are saved
    // as they are, without being validated.
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var draftDomain = getResumableDomain(useLocation().pathname);
    var draftStatus = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (state) { return state.rootReducer.JobSeekerQuestionnaireReducer.draftStatus; });
    var _e = useState(false), isSavingDraft = _e[0], setIsSavingDraft = _e[1];
    var handleSaveForLater = function () {
        if (!draftDomain)
            return;
        setSubmitError("");
        setIsSavingDraft(true);
        dispatch(QuestionnaireDraftAction(draftDomain, toDraftAnswers(answersWithSliderDefaults())));
    };
    useEffect(function () {
        if (!isSavingDraft)
            return;
        if (draftStatus === Status.Successful) {
            navigate("/questionnaire/saved");
        }
        else if (draftStatus === Status.Error) {
            setIsSavingDraft(false);
            setSubmitError("Your progress could not be saved. Please check your internet connection and try again.");
        }
    }, [isSavingDraft, draftStatus, navigate]);
    // Function to fill and submit the form with random data
    var handleDevModeAutoFill = function () {
        if (data && data.length > 0) {
            // Generate random form data
            var randomData_1 = generateRandomFormData(data);
            console.log("[DevMode] Generated random data for form", randomData_1);
            // Set the random data to the form
            setFormData(randomData_1);
            // Clear any error messages
            setErrorMessage(emptyformData);
            setSubmitError("");
            // Submit the random data directly to avoid race condition with state updates
            console.log("[DevMode] Auto-submitting form with random data");
            // Small delay to ensure UI updates before submitting
            setTimeout(function () {
                if (handleSubmit) {
                    handleSubmit(randomData_1);
                }
            }, 100);
        }
    };
    return (_jsxs("div", __assign({ className: "questionnaire px-4 py-4 md:px-8 md:py-10 lg:px-16 lg:py-12 sm:max-w-2xl md:max-w-6xl mx-auto" }, { children: [_jsx(JSQuestionnaireHeader, { title: props.title, content: props.content, classname: props.classname || "", width: props.width || "", hideProgress: props.hideProgress }), _jsx("div", __assign({ className: "questionnaire-content mt-4 md:mt-6 lg:mt-8" }, { children: isLoading ? (_jsx("div", __assign({ className: "py-8 text-center text-gray-500" }, { children: "Loading questionnaire\u2026" }))) : props.emptyStateMessage ? (_jsx("div", __assign({ className: "py-8 text-center text-gray-500" }, { children: props.emptyStateMessage }))) : data.length === 0 ? (_jsx("div", { children: "No data available." })) : (_jsx("div", __assign({ className: "space-y-6 md:space-y-8" }, { children: data.map(function (item, index) {
                        var itemKey = Object.keys(item)[0];
                        var field = item[itemKey];
                        return (_jsxs("div", __assign({ className: "border-b border-gray-200 pb-6 md:pb-8 last:border-b-0" }, { children: [field.field_type === "MatrixRadioSelect" ? (_jsx(MatrixRadioSelect, { data: __assign(__assign({}, field), { choices: field.choices || [], data: field.data || [] }), handleChange: handleChange, handleSelect: handleSelect, handleResponse: handleResponse, formData: Object.fromEntries(Object.entries(formData).map(function (_a) {
                                        var k = _a[0], v = _a[1];
                                        return [
                                            k,
                                            typeof v === "string" ? v : v[0] || "",
                                        ];
                                    })), errorMessage: Object.fromEntries(Object.entries(errorMessage).map(function (_a) {
                                        var k = _a[0], v = _a[1];
                                        return [
                                            k,
                                            typeof v === "string" ? v : v[0] || "",
                                        ];
                                    })), useSlider: isSlider })) : (_jsxs("div", __assign({ className: "question-answer space-y-4 md:space-y-5" }, { children: [_jsx("p", __assign({ className: "font-medium not-italic set-line-height question text-lg md:text-xl" }, { children: field.label })), (field.field_type === "Select" || field.field_type === "RadioSelect" && isMobile) && field.choices && (_jsxs("select", __assign({ className: "dropdown choices-size w-full max-w-md h-12 px-4 py-2", name: itemKey, value: formData[itemKey], onChange: handleSelect }, { children: [_jsx("option", __assign({ value: "" }, { children: "Select One" })), field.choices.map(function (choice, choiceIndex) { return (_jsx("option", __assign({ value: choice }, { children: choice }), choiceIndex)); })] }))), (field.field_type === "RadioSelect" && !isMobile && !isSlider ||
                                            field.field_type === "CheckboxSelectMultiple") &&
                                            field.choices && (_jsx("div", __assign({ className: field.field_type === "RadioSelect"
                                                ? "flex flex-row flex-wrap gap-3 md:gap-4"
                                                : "space-y-3" }, { children: field.choices.map(function (choice, choiceIndex) {
                                                var _a, _b;
                                                var isDisabled = field.field_type === "CheckboxSelectMultiple" &&
                                                    ((_b = (_a = props.disabledCheckboxOptions) === null || _a === void 0 ? void 0 : _a[itemKey]) === null || _b === void 0 ? void 0 : _b.has(choice));
                                                return (_jsxs("p", __assign({ className: "choices choices-size flex font-medium not-italic set-line-height ".concat(isDisabled ? "opacity-50 cursor-not-allowed" : "") }, { children: [_jsx(Input, { type: handleInputType(field.field_type) || "text", className: "select-input w-5 h-5 md:w-6 md:h-6 mr-3 ".concat(isDisabled ? "cursor-not-allowed" : ""), name: itemKey, value: choice, onChange: handleChange, onInputChange: function () { }, isChecked: handleResponse(itemKey, choice, field.field_type), disabled: isDisabled }), _jsx("label", __assign({ className: "select-label text-base md:text-lg ".concat(isDisabled ? "cursor-not-allowed" : "") }, { children: choice }))] }), choiceIndex));
                                            }) }))), field.field_type === "RadioSelect" && !isMobile && isSlider && field.choices && (function () {
                                            var sliderChoices = field.choices.filter(function (choice) { return choice !== "Prefer not to say"; });
                                            return (_jsx(QuestionnaireSlider, { name: itemKey, value: formData[itemKey] === "Prefer not to say"
                                                    ? "Prefer not to say"
                                                    : Number(formData[itemKey]) || 0, onChange: function (name, value) {
                                                    var syntheticEvent = {
                                                        target: {
                                                            name: name,
                                                            value: value,
                                                            type: "radio"
                                                        }
                                                    };
                                                    handleChange(syntheticEvent);
                                                }, label: field.label, min: 0, max: sliderChoices.length - 1, choices: sliderChoices }));
                                        })(), field.field_type === "TextInput" && (_jsx(Input, { type: "text", id: "", name: itemKey, placeholder: "", value: formData[itemKey], onChange: handleChange, className: "choices choices-size input-size w-full max-w-md h-12 px-4 py-2", onInputChange: function () { } }))] }))), !formData[itemKey] && errorMessage[itemKey] && (_jsx(ErrorMessage, { message: errorMessage[itemKey] }, itemKey))] }), index));
                    }) }))) })), _jsx(JSQuestionnaireFooter, { onSubmit: handleFormSubmit, onBack: handleFormBackBtn, disableSubmit: isLoading, hideSubmit: props.hideSubmit, submitLabel: props.submitLabel, onSaveForLater: draftDomain && !props.emptyStateMessage ? handleSaveForLater : undefined, disableSaveForLater: isLoading || isSavingDraft }), _jsx("div", __assign({ className: "my-4" }, { children: _jsx(ErrorMessage, { message: submitError }, "submit-error") })), _jsx(DevModeButton, { onClick: handleDevModeAutoFill })] })));
}
export default QuestionnaireOrg;
